export default __webpack_public_path__ + "static/media/error.e51b0fb0.svg";